// extracted by mini-css-extract-plugin
export default {"signaturePadContainer":"ibjUfxeWHoIN4ZNOkSOU","instructions":"hK2uPoKFSvtOC8ZiLk5A","signingLine":"ECoapd71aKBHL2XMWwdm","clearButton":"vjgZ7M8epWY00kndWJsC"};